const crudModes = {
	CREATE: 'CREATE',
	EDIT: 'EDIT',
	VIEW: 'VIEW',
};

export default crudModes;
